import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import { API_URL } from "../../../helpers/app_url";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  CardHeader,
  CardTitle
} from "reactstrap"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import EligibilitypagesMenu from "../menu/eligibilitypages-menu";
import LeadEligibilityBreadcrumb from "components/Common/LeadEligibilityBreadcrumb";
import SaveButton from "components/buttons/save";
import axios from "axios";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"

class EligibilityOverview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      questions: ''
    }

  }
 
componentDidMount(){

}



  render() {

    return (
      <React.Fragment>

        <ToastContainer autoClose={2000} />

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Eligibility Overview | Realty Space</title>
          </MetaTags>
          <Container fluid className="">


            <Row className="mb20 project-header">
              <Col xl="6">
                <LeadEligibilityBreadcrumb
                  title={this.props.t("Lead")}

                  breadcrumbItem={this.props.t("Overview")}
                />

              </Col>

            </Row>
            <Row>


              <Col xl="12">

                <Card>
                  <CardBody>
                    <EligibilitypagesMenu />
                    {/* <Row className="align-items-stretch">
                     

                      <Col sm="12">
                        <div className="link-page">

                          <div className="open-bg">
                          <h4>What Is the Lead Eligibility Score? </h4>
                          <p>The <strong>Lead Eligibility Score</strong> helps you evaluate and prioritize your leads based on how well they match your ideal client profile. It’s a customizable scoring system that uses key criteria — such as decision timing, mortgage status, reason for purchase, and location — to give each lead a total score. </p>
                          <p>This score helps you focus your time and energy on the most qualified and relevant prospects. </p>
                          <h4>Why It Matters </h4>
                          <p>Not all leads are equal. Some are ready to act now, some are casually browsing. Some are in your farming area, others are outside your zone. The Lead Eligibility Score helps you: 
</p>
                            <ul className="">
                              <li>Quickly identify high-quality leads</li>
                              <li>Customize your follow-up strategy</li>
                              <li>Work smarter — not harder </li>
                            </ul>
                         <h4>How It Works </h4>
                         <p>There are <strong>four key scoring factors:</strong> </p>
                            <ol>
                                <li><strong>Decision Stage </strong> – How soon the lead is planning to buy </li>
                                <li><strong>Mortgage Status </strong> – Whether they’re financially prepared </li>
                                <li><strong>Reason for Purchase</strong> – What’s motivating their move </li>
                                <li><strong>Location</strong> – How well their area of interest fits your market </li>
                            </ol>

                            <p>Each factor has its own configuration: </p>
                              <ul className="">
                              <li>    You decide <strong>how important</strong> each factor is to your business </li>
                              <li>    You assign <strong>scores to each option</strong> based on what you value most </li>
                              <li>    For <strong>Location</strong>, you also tag your primary and secondary markets </li>
                            </ul>

                             <p>The system will automatically calculate a score for every new lead based on these settings — giving you a powerful way to filter and prioritize your pipeline. </p>
                          </div>
                        </div>
                      </Col>
                    </Row> */}
                   
                  </CardBody>
                </Card>


              



              </Col>

            </Row>
              <Row>
                    <Col sm="4" className="d-flex">
                      <Card className="border-full mt-4 w-100 rs-question">
                        <CardHeader>
                          <h4> What Is the Lead Eligibility Score?</h4>
                        </CardHeader>
                        <CardBody className="d-flex flex-column ">
                            <p>The <strong>Lead Eligibility Score</strong> helps you evaluate and prioritize your leads based on how well they match your ideal client profile. It’s a customizable scoring system that uses key criteria — such as decision timing, mortgage status, reason for purchase, and location — to give each lead a total score. </p>
                          <p>This score helps you focus your time and energy on the most qualified and relevant prospects. </p>
                        </CardBody>
                      </Card>
                    </Col>

                      <Col sm="4" className="d-flex">
                      <Card className="border-full mt-4 w-100 rs-question">
                        <CardHeader>
                          <h4>Why It Matters </h4>
                        </CardHeader>
                        <CardBody className="d-flex flex-column">
                           <p>Not all leads are equal. Some are ready to act now, some are casually browsing. Some are in your farming area, others are outside your zone. The Lead Eligibility Score helps you: 
</p>
                            <ul className="">
                              <li>Quickly identify high-quality leads</li>
                              <li>Customize your follow-up strategy</li>
                              <li>Work smarter — not harder </li>
                            </ul>
                        </CardBody>
                      </Card>
                    </Col>

                       <Col sm="4" className="d-flex">
                      <Card className="border-full mt-4 w-100 rs-question">
                        <CardHeader>
                          <h4>How it works</h4>
                        </CardHeader>
                        <CardBody className="d-flex flex-column">
                           <p>There are <strong>four key scoring factors:</strong> </p>
                            <ol>
                                <li><strong>Decision Stage </strong> – How soon the lead is planning to buy </li>
                                <li><strong>Mortgage Status </strong> – Whether they’re financially prepared </li>
                                <li><strong>Reason for Purchase</strong> – What’s motivating their move </li>
                                <li><strong>Location</strong> – How well their area of interest fits your market </li>
                            </ol>

                            <p>Each factor has its own configuration: </p>
                              <ul className="">
                              <li>    You decide <strong>how important</strong> each factor is to your business </li>
                              <li>    You assign <strong>scores to each option</strong> based on what you value most </li>
                              <li>    For <strong>Location</strong>, you also tag your primary and secondary markets </li>
                            </ul>

                             <p>The system will automatically calculate a score for every new lead based on these settings — giving you a powerful way to filter and prioritize your pipeline. </p>
                        </CardBody>
                      </Card>
                    </Col>
                </Row>


          </Container>
        </div>
      </React.Fragment>
    )
  }
}
EligibilityOverview.propTypes = {
  t: PropTypes.any,



}
const mapStateToProps = ({ }) => (
  {



  })
const mapDispatchToProps = dispatch => ({



});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EligibilityOverview))
